import { type QueryClient, useQuery } from '@tanstack/react-query';
import {
  StatusCode,
  getCustomerExperiments,
  type GetCustomerExperimentsParams,
} from '@hungryroot/rest';

const DEFAULT_PARAMS: Pick<GetCustomerExperimentsParams, 'limit' | 'offset'> = {
  limit: 999,
  offset: 0,
};

export type Props = {
  enabled: boolean;
};

export const invalidateCustomerExperiments = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: ['customer-experiments'] });
};

export function useApiV2CustomerExperiments({ enabled }: Props) {
  return useQuery({
    queryKey: ['customer-experiments'],
    queryFn: async () => {
      const resp = await getCustomerExperiments(DEFAULT_PARAMS);
      if (resp.status !== StatusCode.SuccessOK) {
        throw resp.data;
      }

      return resp.data;
    },
    select(data) {
      return {
        experiments: data.results,
      };
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
